import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NavigationComponent} from './components/navigation/navigation.component';
import {FooterComponent} from './components/footer/footer.component';
import {Title} from "@angular/platform-browser";
import {SharedService} from "./services/shared/shared.service";

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        NavigationComponent,
        FooterComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    branding: string = '';

    constructor(private title: Title, private shared: SharedService) {
        if (typeof window !== "undefined") {
            if (window.location.hostname.includes('einhorn')) {
                this.branding = "einhornkraut";
                this.title.setTitle('Einhornkraut Paymentservice')
            } else {
                this.branding = 'arztapp';
                this.changeFavicon('assets/icons/PatriaCura_Logo_48.png');
                this.title.setTitle('Patriacura Paymentservice')
            }
        }
        this.shared.branding = this.branding;
    }

    private changeFavicon(url: string): void {
        const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = url;
        document.getElementsByTagName('head')[0].appendChild(link);
    }
}
